import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Input,
    Button,
    FormControl,
    FormLabel,
    useDisclosure,
    Box,
    Center,
    VStack,
    HStack,
  } from "@chakra-ui/react";
import React from "react"

function Results() {
    const { isOpen, onOpen, onClose } = useDisclosure()
  
    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)
  
    return (
      <>
        <Button colorScheme="teal" onClick={onOpen}>Results</Button>
        
  
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Results</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Result Name</FormLabel>
                <Input ref={initialRef} placeholder='Enter Result Name' />
              </FormControl>
  
              <FormControl mt={4}>
                <FormLabel>Google Drive Link</FormLabel>
                <Input placeholder='Enter Chapter name' />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Google Drive Link</FormLabel>
                <Input placeholder='Enter link' />
              </FormControl>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3}>
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
  export default Results